"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OuterLoader = exports.LoaderContainer = exports.InnerLoader = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _LoaderKeyFrames = require("./LoaderKeyFrames.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Loaderborder = `
	border: 3px solid black;
	border-radius: 50%;
	border-bottom: 3px solid transparent;
`;
const InnerLoader = exports.InnerLoader = _styledComponents.default.div`
	width: 60%;
	height: 60%;
	animation: ${_LoaderKeyFrames.antiClockSpinner} 500ms infinite;
	position: relative;
	${Loaderborder}
`;
const OuterLoader = exports.OuterLoader = _styledComponents.default.div`
	width: ${props => props.size ? `${props.size}px` : '30px'};
	height: ${props => props.size ? `${props.size}px` : '30px'};
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	animation: ${_LoaderKeyFrames.clockSpinnerAnimation} 1s infinite;
	${Loaderborder}
`;
const LoaderContainer = exports.LoaderContainer = _styledComponents.default.div`
	${({
  isFullPage
}) => {
  return isFullPage ? (0, _styledComponents.css)`
					position: fixed;
					z-index: 1000;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
			  ` : '';
}}
`;